module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Renee-meisje-doopsuiker-geboorte-3.80ee3aeb.jpg";